import { MutableRefObject } from 'react'

import i18n from 'modules/core/lib/i18n'

export const initialSurveyPrompt: MutableRefObject<string> = {
  current: '',
}

export const getPromptPlaceholders = () => {
  return [
    i18n.t('surveys.new_create_survey_modal.placeholders.attendees_engagement'),
    i18n.t('surveys.new_create_survey_modal.placeholders.employees_engagement'),
    i18n.t('surveys.new_create_survey_modal.placeholders.team_morale'),
  ]
}
